import { render } from "./PropertyExpenses.vue?vue&type=template&id=13ec4fea"
import script from "./PropertyExpenses.vue?vue&type=script&lang=js"
export * from "./PropertyExpenses.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__